const AI_CHAT_STYLES_ID = 'ai-chat-styles';
const AI_CHAT_STYLES_HREF = '/core/assets/ai-chat/styles.css';

/** Подключает глобальные стили виджета (ui-kit + компоненты) на страницах без spa2. */
export function loadAiChatStyles(): void {
  if (document.getElementById(AI_CHAT_STYLES_ID)) {
    return;
  }

  const link = document.createElement('link');
  link.id = AI_CHAT_STYLES_ID;
  link.rel = 'stylesheet';
  link.href = AI_CHAT_STYLES_HREF;
  document.head.appendChild(link);
}
